import { SimOutlineIcon } from './SimOutlineIcon';

/**
 * author: Michael Irigoyen
 * id C886D757-3CAE-4BAF-9F51-0747142FC508
 * name sim-outline
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sim-outline.svg
 * tags
 * - Cellphone / Phone 
 */
export const SubscriberIdentityModuleOutlineIcon = SimOutlineIcon;
export default SubscriberIdentityModuleOutlineIcon